const cards = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20panel%20illustration%20space%20battle%20between%20two%20armadas%20laser%20cannons%20firing%20against%20colorful%20nebula%20backdrop%20dramatic%20composition%20warm%20orange%20explosion%20colors%20manga%20art%20style&width=600&height=400&seq=card-rec-1&orientation=landscape',
    tag: '编辑精选',
    title: '银河帝国编年史',
    desc: '横跨三千年的银河文明史诗，从第一次星际航行到银河联邦的建立与衰落',
    info: '已完结 · 全 342 话',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20scene%20interior%20of%20alien%20spaceship%20bioluminescent%20walls%20strange%20organic%20technology%20human%20explorer%20touching%20glowing%20surface%20mysterious%20atmosphere%20warm%20amber%20light&width=600&height=400&seq=card-rec-2&orientation=landscape',
    tag: '新作力荐',
    title: '星际流浪者',
    desc: '孤独的赏金猎人在银河边缘邂逅神秘少女，一场横跨星域的逃亡与救赎之旅',
    info: '连载中 · 更新至 23 话',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20illustration%20cybernetic%20detective%20in%20rainy%20futuristic%20alley%20neon%20holographic%20advertisements%20noir%20atmosphere%20holding%20a%20glowing%20data%20chip%20warm%20orange%20neon%20reflections&width=600&height=400&seq=card-rec-3&orientation=landscape',
    tag: '人气飙升',
    title: '量子深渊',
    desc: '量子物理学家意外发现意识可以穿越平行宇宙，一场烧脑的科幻悬疑之旅',
    info: '连载中 · 更新至 18 话',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20scene%20alien%20ocean%20planet%20giant%20aquatic%20creatures%20breaching%20surface%20under%20twin%20suns%20research%20submarine%20approaching%20vibrant%20colors%20manga%20illustration&width=600&height=400&seq=card-rec-4&orientation=landscape',
    tag: '经典回顾',
    title: '深海星辰',
    desc: '在全部由海洋覆盖的外星球上，人类殖民者与深海智慧生命的第一次接触',
    info: '已完结 · 全 156 话',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20panel%20giant%20space%20elevator%20connecting%20planet%20surface%20to%20orbital%20station%20construction%20workers%20in%20space%20suits%20epic%20scale%20warm%20sunrise%20lighting%20detailed&width=600&height=400&seq=card-rec-5&orientation=landscape',
    tag: '口碑佳作',
    title: '天梯',
    desc: '人类建造首座太空电梯的宏大工程故事，技术挑战与人性的双重考验',
    info: '连载中 · 更新至 67 话',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20art%20alien%20diplomat%20and%20human%20ambassador%20negotiating%20in%20grand%20futuristic%20hall%20with%20holographic%20star%20map%20between%20them%20tense%20atmosphere%20warm%20golden%20lighting&width=600&height=400&seq=card-rec-6&orientation=landscape',
    tag: '深度推荐',
    title: '星盟纪元',
    desc: '政治博弈与星际战争交织，讲述人类在银河政治舞台上的崛起之路',
    info: '连载中 · 更新至 142 话',
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20illustration%20young%20space%20cadet%20at%20academy%20training%20ground%20zero%20gravity%20combat%20simulation%20other%20cadets%20in%20background%20inspiring%20atmosphere%20warm%20sunlight%20through%20viewport&width=600&height=400&seq=card-rec-7&orientation=landscape',
    tag: '青春热血',
    title: '星际学院',
    desc: '银河联邦军事学院的年轻学员们在训练与实战中成长为合格星际战士的故事',
    info: '连载中 · 更新至 89 话',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            编辑团队每日甄选，优质科幻漫画一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 4).map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-colors no-underline block cursor-pointer"
            >
              <div className="w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4">
                <span className="inline-block text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium mb-2 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                  {card.desc}
                </p>
                <p className="text-xs text-foreground-400 whitespace-nowrap">{card.info}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(4).map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-colors no-underline block cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-36 md:w-44 h-36 md:h-40 overflow-hidden flex-shrink-0">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-4 flex flex-col justify-center flex-1">
                <span className="inline-block text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium mb-1.5 whitespace-nowrap self-start">
                  {card.tag}
                </span>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-1.5 line-clamp-2">
                  {card.desc}
                </p>
                <p className="text-xs text-foreground-400 whitespace-nowrap">{card.info}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}